<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    ></qx-search-box>
    <TableBox ref="tableBox" @getChartData="getChartData" />
  </section>
</template>

<script>
import { getMonthFirstToLastDate } from '@qx/utils';
import TableBox from './tableBox';
import {
  customerArchivesList,
} from 'api/archives';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      chartData: {},
      searchBoxData: {
        form: [
          {
            label: '对比模式',
            value: 'mode',
            type: 'radio',
            default: 1,
            hide: false,
            options: [
              { label: '按客户', value: 1 },
              { label: '按月份', value: 2 },
            ],
            onChange: () => {
              this.handleModeChange(true);
            },
          },
          {
            label: '客户全称',
            value: 'custName',
            type: 'el-autocomplete',
            valueKey: 'customerName',
            placeholder: '请输入客户全称',
            querySearchAsync: (queryString, cb) => {
              let result = [];
              if (queryString && queryString.length) {
                customerArchivesList({ customerName: queryString }).then((res) => {
                  if (res && res.items) {
                    result = res.items;
                  }
                  cb(result);
                });
              }
              cb(result);
            },
            onSelect: async (item) => {
              if (item) {
                this.$nextTick(() => {
                  this.$refs.searchBox.sub();
                });
              }
            },
          },
          {
            label: '月份',
            value: 'Time',
            type: 'date',
            default: getMonthFirstToLastDate()[0],
            attr: {
              type: 'month',
            },
            hide: true,
          },
          {
            label: '开始月份',
            value: 'startTime',
            type: 'date',
            default: getMonthFirstToLastDate()[0],
            attr: {
              type: 'month',
            },
          },
          {
            label: '结束月份',
            value: 'endTime',
            type: 'date',
            default: getMonthFirstToLastDate()[0],
            attr: {
              type: 'month',
            },
          },
        ],
      },
    };
  },
  methods: {
    getChartData () {
      this.$refs.tableBox.setBarChartData(this.chartData);
    },
    handleModeChange (isGetData) {
      const mode = this.$refs.searchBox.getVal('mode');
      let hideNames = [];
      let showNames = [];
      if (mode === 1) {
        hideNames = ['startTime', 'endTime'];
        showNames = ['Time'];
      } else {
        hideNames = ['Time'];
        showNames = ['startTime', 'endTime'];
      }
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'hide',
        value: true,
        names: hideNames,
      });
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'hide',
        value: false,
        names: showNames,
      });
      if (isGetData) {
        this.$refs.searchBox.sub();
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.mode === 1) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time, 3);
        searchBoxData.endTime = searchBoxData.startTime;
      } else {
        searchBoxData.startTime = this.formatDate(searchBoxData.startTime, 3);
        searchBoxData.endTime = this.formatDate(searchBoxData.endTime, 3);
      }
      delete searchBoxData.Time;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);

      this.chartData = searchBoxData;
      this.getChartData();
    },
  },
  async mounted () {
    this.handleModeChange();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .chooseContentClass {
  width: auto;
}
</style>
